import { TextField, Theme, Typography } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import {
  confirmUserPasswordRecovery,
  confirmUserRegistrationCode,
  updatePasswordRecovery,
} from 'lib/api';
import EnhancedBox from 'lib/designSystem/BigBox';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AuthState, logout } from 'services/redux/authSlice';

import { Copyright } from '../EnrolationForm';

const ConfirmUserRegistrationAdmin = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const { code } = useParams<{ code: string }>();
  const [error, setError] = useState(false);
  const userRedux = useSelector(
    (state: { auth: AuthState }) => state.auth.user,
  );

  const confirmCodeUser = async () => {
    try {
      setLoading(true);
      const userResponse = await confirmUserPasswordRecovery({ code });
      if (!userResponse.success) setError(true);
    } catch (error) {
      setError(true);
    }

    setLoading(false);
  };
  useEffect(() => {
    void confirmCodeUser();
  }, []);

  const passwordValidations = () => {
    if (!password) return alert('Ingresa una contraseña');
    if (password !== confirmPassword)
      return alert('Las contraseñas no coinciden');
    if (password.length < 8)
      return alert('La contraseña debe tener al menos 8 caracteres');
    if (password.length > 20)
      return alert('La contraseña debe tener máximo 20 caracteres');
    if (!password.match(/[A-Z]/g))
      return alert('La contraseña debe tener al menos una letra mayúscula');
    if (!password.match(/[a-z]/g))
      return alert('La contraseña debe tener al menos una letra minúscula');
    return true;
  };

  const handleSubmit = async () => {
    if (!passwordValidations()) return;
    setLoading(true);
    try {
      const payload = {
        code,
        password,
        name,
      };
      const resposne = await updatePasswordRecovery(payload);
      if (!resposne.success) {
        setLoading(false);
        return alert(resposne.message);
      }
      const userResponse = await confirmUserRegistrationCode({ code });
      if (!userResponse.success) {
        setLoading(false);
        return alert(userResponse.message);
      }
      alert(
        'Se ha actualizado la contraseña, por favor ingresa con tu nueva contraseña',
      );
      if (userRedux) {
        dispatch(logout());
      }
      window.location.href = `/`;
    } catch (error) {
      alert('Usuario no existe');
    }
    setLoading(false);
  };

  if (loading) return <CenteredCircularProgress type="noLayout" />;

  if (error) {
    return (
      <div style={{ margin: 'auto', maxWidth: '40%', padding: 40 }}>
        <Typography variant="h4">Error</Typography>
        <Typography variant="h6">
          El código ingresado no tiene validez
        </Typography>
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: '#F8FAFC', height: '100vh' }}>
      <div style={{ margin: 'auto', maxWidth: '40%', padding: 40 }}>
        {/* <HeaderWithActions variant='h4' subHeader buttons={[]} title='Confirmación de registro' /> */}
        <EnhancedBox>
          <Typography style={{ padding: '6px 0px' }} variant="h3">
            Confirmación exitosa
          </Typography>
          <Typography variant="body1">
            Hemos verificado tu email. Por favor ingresa la información restante
            para poder ingresar a Pruff.{' '}
          </Typography>
          <div style={{ paddingTop: 20 }}>
            <TextField
              variant="outlined"
              label="Nombre"
              value={name}
              onChange={(e) => setName(e.target.value)}
              fullWidth
              style={{ marginBottom: 20 }}
              autoComplete="off"
            />
            <TextField
              variant="outlined"
              label="Contraseña"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
              style={{ marginBottom: 20 }}
              autoComplete="new-password"
            />
            <TextField
              variant="outlined"
              label="Repetir contraseña"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              fullWidth
              autoComplete="new-password"
              style={{ marginBottom: 20 }}
            />
            <div style={{ paddingBottom: 20 }}>
              <Typography variant="body1">
                La contraseña debe tener al menos 8 caracteres, una letra
                mayúscula y una minúscula
              </Typography>
            </div>
            <CustomButton
              color="primary"
              onClick={() => handleSubmit()}
              disabled={loading}
              fullWidth
              style={{ marginBottom: 20 }}
            >
              Ingresar
            </CustomButton>
          </div>
        </EnhancedBox>
      </div>
      <div style={{ paddingTop: 40 }}>
        <Copyright />
      </div>
    </div>
  );
};

export default ConfirmUserRegistrationAdmin;
